module.exports = __webpack_public_path__ + "static/media/terms_of_use_general.fc4a60a9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/terms_of_use_general.pdf
// module id = 172
// module chunks = 29